import { IEntityMetaData, IPropretyAttribute } from "../../_models/IEntityMetaData";
import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { PropretyAttributes, NestedProperty, NavigationProperty, Validation } from "../../decorators/EntityDecorators";
import { FSTREAM_Image } from "./FSTREAM_Image.model";
import { PointOfService } from "./PointOfService.model";
import { Account_Tenant_Admin } from "./Account_Tenant_Admin.model";
import { RegexType } from "../../services/RegexPatternLibrary";
import { Register } from "../../decorators/DependencyInjectionRegistreyDecorators";


@Register({
  isModelEntity: true, namespace: 'Tenant', entityName: 'Tenant' // optionnel car par defaut utilise le nom de classe
})
export class Tenant extends GenericEntityBase<number> {
  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.KeyProperty,
      IPropretyAttribute.Readonly
    ]
  })
  id: number = GenericEntityBase.GetDefaultId(KeyType.number);

  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.FilterColumn,
      IPropretyAttribute.SortColumn,
      IPropretyAttribute.Required
    ],
    PropretyDisplayName: "Organization Name"
  })
  @Validation({
    propertyType: RegexType.StartsWithCapital,               //    Avec Auto-completion !!!
    minLength: 2,
    maxLength: 50,
    pattern: '^[A-Za-z][A-Za-z0-9 @#\$%&\*\-_\+\./\?!]{2,49}$',
  })
  organizationName!: string;

  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.FilterColumn,
      IPropretyAttribute.SortColumn,
      IPropretyAttribute.Required
    ],
    PropretyDisplayName: "Prefix"
  })
  @Validation({
    propertyType: RegexType.Alphanumeric,               //    Avec Auto-completion !!!
    minLength: 2,
    maxLength: 50,
  })
  prefix!: string;

  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.FilterColumn,
      IPropretyAttribute.SortColumn,
      IPropretyAttribute.Required
    ]
  })
  @Validation({
    propertyType: RegexType.CivicNumberCA,
  })
  civicNumber!: string;

  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.FilterColumn,
      IPropretyAttribute.SortColumn,
      IPropretyAttribute.Required
    ]
  })
  @Validation({
    propertyType: RegexType.Street,
  })
  street!: string;

  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.FilterColumn,
      IPropretyAttribute.SortColumn,
      IPropretyAttribute.Required
    ]
  })
  @Validation({
    propertyType: RegexType.Alphanumeric,
    minLength: 1,
    maxLength: 20
  })
  officeNumber?: string;

  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.FilterColumn,
      IPropretyAttribute.SortColumn,
      IPropretyAttribute.Required
    ]
  })
  @Validation({
    propertyType: RegexType.Alphabetic,
    minLength: 1,
    maxLength: 30
  })
  city!: string;

  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.FilterColumn,
      IPropretyAttribute.SortColumn,
      IPropretyAttribute.Required
    ]
  })
  @Validation({
    propertyType: RegexType.Alphabetic,
    minLength: 1,
    maxLength: 30
  })
  state?: string;

  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.FilterColumn,
      IPropretyAttribute.SortColumn,
      IPropretyAttribute.Required
    ]
  })
  @Validation({
    propertyType: RegexType.Alphabetic,
    minLength: 1,
    maxLength: 20
  })
  country!: string;

  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.FilterColumn,
      IPropretyAttribute.SortColumn,
      IPropretyAttribute.Required
    ]
  })
  @Validation({
    propertyType: `${RegexType.PostalCodeCA}|${RegexType.PostalCodeUS}`
  })
  postalCode!: string;

  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.FilterColumn,
      IPropretyAttribute.SortColumn,
      IPropretyAttribute.Required
    ],

    PropretyDisplayName: "Account Representative"
  })

  @Validation({
    propertyType: RegexType.StartsWithCapital,
    minLength: 2,
    maxLength: 50,
    pattern: '^[A-Za-z][A-Za-z0-9 @#\$%&\*\-_\+\./\?!]{2,49}$',
    validationErrorMessage: 'Representative Full-name must be alphanumeric (with length between 2 and 50)'
  })
  accountRepresentative!: string;

  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.FilterColumn,
      IPropretyAttribute.SortColumn,
      IPropretyAttribute.Required
    ],
    PropretyDisplayName: "Account Phone Number"
  })

  @Validation({
    propertyType: RegexType.NorthAmericanPhone,
    minLength: 10,
    maxLength: 15
  })
  accountPhoneNumber!: string;

  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.FilterColumn,
      IPropretyAttribute.SortColumn,
      IPropretyAttribute.Required
    ],
    PropretyDisplayName: "Account Email"
  })
  @Validation({
    propertyType: RegexType.Email,
    minLength: 9,
    maxLength: 50
  })
  accountEmail!: string;

  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.FilterColumn,
      IPropretyAttribute.SortColumn,
      IPropretyAttribute.Required
    ],
    PropretyDisplayName: "Active"
  })
  isActive!: boolean;

  fK_Image_Logo?: number;

  @NestedProperty({
    PropretyDisplayName: "Logo Image",
    PropretyPluralName: "Logo Images",
    ShowInTab: false,
    AddInplaceProprety: false,
    TargetType: FSTREAM_Image
  })
  imageLogo?: FSTREAM_Image;

  @NavigationProperty({
    PropretyDisplayName: "Point Of Service",
    PropretyPluralName: "Point Of Services",
    ShowInTab: true,
    AddInplaceProprety: true,
    TargetType: PointOfService
  })
  pointOfServices?: PointOfService[];

  @NavigationProperty({
    PropretyDisplayName: "Account Tenant Admin",
    PropretyPluralName: "Account Tenant Admins",
    ShowInTab: true,
    AddInplaceProprety: true
  })
  accountTenantAdmins?: Account_Tenant_Admin[];

  managerClient!: string;

  GetType(): IEntityMetaData {
    return Tenant.getMetaData();
  }
}

